/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	DateTime: `scalar.DateTime` as const,
	AccountStatus: "enum" as const,
	RoleEnum: "enum" as const,
	ScormCompletionStatus: "enum" as const,
	ScormSuccessStatus: "enum" as const,
	Query:{
		getRole:{

		},
		getPermission:{

		},
		getMail:{

		},
		loginAsGuest:{

		},
		uniqueAuthFromSso:{

		},
		getUser:{

		},
		getFilteredUsers:{
			findManyUserWithFiltersInput:"FindManyUserWithFiltersInput"
		},
		getScormTrackings:{
			input:"FindManyScormTrackingWithFiltersInput"
		},
		downloadFile:{

		},
		publishBasicSubscription:{

		}
	},
	EError: "enum" as const,
	FindManyUserWithFiltersInput:{
		orderBy:"UserOrderByInput",
		filterBy:"UserFilterByInput"
	},
	UserOrderByInput:{
		email:"OrderByEnum",
		firstName:"OrderByEnum",
		lastName:"OrderByEnum",
		lastConnectionAt:"OrderByEnum",
		role:"OrderByEnum"
	},
	OrderByEnum: "enum" as const,
	UserFilterByInput:{

	},
	FindManyScormTrackingWithFiltersInput:{
		orderBy:"ScormTrackingOrderByInput",
		filterBy:"ScormTrackingFilterByInput"
	},
	ScormTrackingOrderByInput:{
		userEmail:"OrderByEnum",
		userFirstName:"OrderByEnum",
		userLastName:"OrderByEnum",
		completionStatus:"OrderByEnum",
		successStatus:"OrderByEnum",
		scoreRaw:"OrderByEnum",
		completedAt:"OrderByEnum"
	},
	ScormTrackingFilterByInput:{
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus"
	},
	Mutation:{
		login:{

		},
		askForResetPassword:{

		},
		reSendEmailValidation:{

		},
		resetPassword:{

		},
		verifyEmail:{

		},
		register:{

		},
		askForRegister:{
			registerUserInput:"RegisterUserInput"
		},
		finishRegister:{

		},
		finishRegisterAsGuest:{

		},
		impersonateUser:{

		},
		createUser:{
			createUserInput:"CreateUserInput"
		},
		updateUser:{
			updateUserInput:"UpdateUserInput"
		},
		deleteUser:{

		},
		upsertScormTracking:{
			input:"UpsertScormTrackingInput"
		},
		deleteFile:{

		},
		uploadPreSignedUrl:{

		},
		confirmUpload:{

		}
	},
	RegisterUserInput:{

	},
	CreateUserInput:{

	},
	UpdateUserInput:{

	},
	UpsertScormTrackingInput:{
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus"
	},
	Subscription:{
		basicSubscription:{

		}
	},
	ID: `scalar.ID` as const
}

export const ReturnTypes: Record<string,any> = {
	Permissions:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		roles:"Role"
	},
	DateTime: `scalar.DateTime` as const,
	Users:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		status:"AccountStatus",
		email:"String",
		password:"String",
		passwordResetToken:"String",
		passwordResetExpiryDate:"DateTime",
		activateAccountToken:"String",
		activateAccountExpiryDate:"DateTime",
		emailVerified:"Boolean",
		verifyEmailToken:"String",
		verifyEmailExpiryDate:"DateTime",
		firstName:"String",
		lastName:"String",
		refreshToken:"String",
		role:"Role",
		roleId:"String"
	},
	UserPagination:{
		users:"Users",
		total:"Int"
	},
	Role:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		name:"String",
		permissions:"Permissions",
		users:"Users"
	},
	UniqueAuth:{
		access_token:"String",
		refresh_token:"String",
		firstName:"String",
		lastName:"String",
		role:"String",
		email:"String",
		id:"String"
	},
	UserInfo:{
		firstName:"String",
		lastName:"String",
		roles:"RoleEnum",
		email:"String",
		id:"String"
	},
	DownloadFile:{
		fileName:"String",
		fileMimeType:"String",
		url:"String"
	},
	MyFiles:{
		id:"String",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		eTag:"String",
		location:"String",
		fileName:"String",
		fileMimeType:"String",
		ownerId:"String"
	},
	UploadPreSignedUrl:{
		url:"String",
		id:"String"
	},
	Mail:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		key:"String",
		to:"String",
		data:"String"
	},
	ScormTrackingModel:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMin:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		sessionTime:"String",
		suspendData:"String",
		location:"String",
		completedAt:"DateTime",
		userId:"String"
	},
	ScormTrackingWithUser:{
		id:"ID",
		createdAt:"DateTime",
		updatedAt:"DateTime",
		completionStatus:"ScormCompletionStatus",
		successStatus:"ScormSuccessStatus",
		scoreRaw:"Float",
		scoreMin:"Float",
		scoreMax:"Float",
		scoreScaled:"Float",
		totalTime:"String",
		sessionTime:"String",
		suspendData:"String",
		location:"String",
		completedAt:"DateTime",
		userId:"String",
		userEmail:"String",
		userFirstName:"String",
		userLastName:"String"
	},
	ScormTrackingPagination:{
		trackings:"ScormTrackingWithUser",
		total:"Int"
	},
	Health:{
		env:"String",
		time:"String",
		status:"String"
	},
	Query:{
		getHealthGql:"Health",
		getRole:"Role",
		getRoles:"Role",
		getPermission:"Permissions",
		getPermissions:"Permissions",
		getMail:"Mail",
		getMails:"Mail",
		sendMail:"Boolean",
		loginAsGuest:"AuthType",
		uniqueAuthFromSso:"UniqueAuth",
		me:"UserInfo",
		getUser:"Users",
		getUsers:"Users",
		getFilteredUsers:"UserPagination",
		getMyScormTracking:"ScormTrackingModel",
		getScormTrackings:"ScormTrackingPagination",
		downloadFile:"DownloadFile",
		getAllMyFiles:"MyFiles",
		publishBasicSubscription:"Boolean"
	},
	AuthType:{
		"...on UserInfo":"UserInfo",
		"...on CustomError":"CustomError"
	},
	CustomError:{
		error:"EError",
		message:"String"
	},
	Mutation:{
		login:"AuthType",
		askForResetPassword:"Boolean",
		reSendEmailValidation:"Boolean",
		resetPassword:"Boolean",
		verifyEmail:"Boolean",
		register:"AuthType",
		askForRegister:"Boolean",
		finishRegister:"Boolean",
		finishRegisterAsGuest:"Boolean",
		refresh:"AuthType",
		logout:"Boolean",
		impersonateUser:"AuthType",
		createUser:"Users",
		updateUser:"Users",
		deleteUser:"Boolean",
		upsertScormTracking:"ScormTrackingModel",
		deleteFile:"Boolean",
		uploadPreSignedUrl:"UploadPreSignedUrl",
		confirmUpload:"Boolean"
	},
	Subscription:{
		basicSubscription:"String"
	},
	ID: `scalar.ID` as const
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const,
	subscription: "Subscription" as const
}